export default "__VITE_ASSET__DOf05IND__"